import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { USER_ROLES } from '../utils/roles';

const AdminRoute = ({ children }) => {
  const { userRole, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (userRole !== USER_ROLES.ADMIN) {
    if (userRole === USER_ROLES.STAFF) {
      return <Navigate to="/staff-savings" replace />;
    }
    return <Navigate to="/expenses" replace />;
  }

  return children;
};

export default AdminRoute; 